import { t } from 'i18next';

import * as apiArchive from 'apiAuto/backend/paths/DeleteAccessoryIdV1';
import * as apiRestore from 'apiAuto/backend/paths/PostAccessoryRestoreIdV1';
import { Characteristic } from 'enums/characteristic';
import * as AccessoryCategoryList from 'types/Accessory/Search/AccessoryCategoryList';
import * as TagList from 'types/Accessory/Search/TagList';
import * as Co2Label from 'types/Co2/Co2Label';
import * as Icon from 'types/Icon/Icon';
import * as IconList from 'types/Icon/IconList';
import * as Image from 'types/Media/Image';

export type Type = {
	carbonDioxideLabel: Co2Label.Type | null;
	carbonDioxideValue: number | null;
	categories: AccessoryCategoryList.Type;
	characteristic: Characteristic;
	countOfRecipes: number;
	density: number | null;
	id: string;
	image: Image.Type | null;
	lastEditedDateUtc: string;
	lastEditor: string | null;
	name: string;
	price: number | null;
	tags: TagList.Type;
};

export function create(): Type {
	return {
		carbonDioxideLabel: null,
		carbonDioxideValue: null,
		categories: AccessoryCategoryList.create(),
		characteristic: Characteristic.SolidNonQuantifiable,
		countOfRecipes: 0,
		density: null,
		id: '',
		image: null,
		lastEditedDateUtc: '',
		lastEditor: null,
		name: '',
		price: null,
		tags: TagList.create(),
	};
}

export function getIcons(obj: Type): IconList.Type {
	const output: (Icon.Type | null)[] = [];
	output.push(...TagList.mapToIcons(obj.tags));
	return output.filter((x) => x?.iconSvgUrl).map((x) => x as Icon.Type);
}

export function getAuthor(obj: Type): string {
	if (obj.lastEditor) return obj.lastEditor;
	return t('_general:UNKNOWN_AUTHOR');
}

export async function callApiArchive(id: string): Promise<void> {
	await apiArchive.callApi({ pathParameters: { Id: id } });
}

export async function callApiRestore(id: string): Promise<void> {
	await apiRestore.callApi({ pathParameters: { Id: id } });
}
